import { http } from './http'
import { Pagination } from './map'
import {
  ThemeImages,
  WebSettings,
  WebSettingsPayload,
  DefaultImages,
  DefaultImagesPayload,
  SettingsColors,
  ThemeImagesPayload,
  Link,
  LinkPayload,
  SettingsFriends,
  SettingsFriendsPayload,
  FooterSettingsPayload,
  ModuleSettings,
  ModuleSettingsPayload,
  Languages,
  Currencies,
  CurrenciesPayload,
  Menu,
  MenuPayload,
  SettingsGender,
  SettingsGenderPayload,
  FestivalEdition,
  FestivalEditionCreate,
  SettingsLanguages,
  AppSection,
  HeroSettings,
  HeroSettingsPayload,
  FooterSettings,
} from '../../common/models'
import {
  Bonuses,
  BonusesPayload,
  CheckinSettings,
  CheckinSettingsPayload,
  FestivalSettings,
  FestivalSettingsPayload,
  SeoPages,
  SeoSettings,
  SeoSettingsPayload,
  SettingsCountry,
  SettingsCountryPayload,
  Socials,
  SocialsPayload,
  Tickets,
  TicketsPayload,
  Topup,
  TopupPayload,
} from '../../common/models'
import {
  ICryptoSettings,
  ICryptoSettingsPayload,
  IPaymentMethodsSettings,
  IPaymentMethodsSettingsPayload,
  FinancingSettings,
  FinancingSettingsPayload,
  TaxCategoriesSettings,
  TaxCategoriesSettingsPayload,
  FinancialSettingsInvoiceConfig,
  FinancialSettingsCategory,
  FinancialSettingsCategoryTickets,
  IGooglePaySettings,
  IGooglePaySettingsPayload,
  IApplePaySettings,
  IApplePaySettingsPayload,
  IAlcatrazSettings,
  IAlcatrazSettingsPayload,
  IAlcatrazTicketRow,
  IAlcatrazTicketsQuery,
} from '../../common/models/settings'

export const getWebSettings = () =>
  http.get<WebSettings>(`/operations/festivals/web-settings`)

export const updateWebSettings = (data: WebSettingsPayload) =>
  http.put<WebSettings>('/operations/festivals/web-settings', data)

export const getSeoSettings = (page: SeoPages) =>
  http.get<SeoSettings>(`/operations/festivals/page/${page}/seo-settings`)

export const updateSeoSettings = (page: SeoPages, data: SeoSettingsPayload) =>
  http.put<SeoSettings>(`/operations/festivals/page/${page}/seo-settings`, data)

export const getThemeImages = () =>
  http.get<ThemeImages[]>(`/operations/festivals/theme-images`)

export const updateThemeImages = (data: ThemeImagesPayload[]) =>
  http.put<ThemeImages[]>('/operations/festivals/theme-images', data)

export const getGeneralSettings = () =>
  http.get<FestivalSettings>(`/operations/festivals/settings`)

export const updateGeneralSettings = (data: FestivalSettingsPayload) =>
  http.put<FestivalSettings>('/operations/festivals/settings', data)

export const getSettingsLinks = () =>
  http.get<Link[]>(`/operations/festivals/link`)

export const updateSettingsLinks = (data: LinkPayload[]) =>
  http.put<Link[]>('/operations/festivals/link', data)

export const deleteSettingsLink = (id: string) =>
  http.delete(`/operations/festivals/link/${id}`)

export const getDefaultImages = () =>
  http.get<DefaultImages>(`/operations/festivals/default-images`)

export const updateDefaultImages = (data: DefaultImagesPayload) =>
  http.put<DefaultImages>('/operations/festivals/default-images', data)

export const getSettingsColors = () =>
  http.get<SettingsColors[]>(`/operations/festivals/colors`)

export const updateSettingsColors = (data: SettingsColors[]) =>
  http.put<SettingsColors[]>('/operations/festivals/colors', data)

export const getAllLanguages = () =>
  http.get<Languages[]>('/operations/languages')

export const getCurrencies = () =>
  http.get<Currencies>(`/operations/festivals/currencies`)

export const updateCurrencies = (data: CurrenciesPayload) =>
  http.put<Currencies>('/operations/festivals/currencies', data)

export const getSettingsCountries = () =>
  http.get<SettingsCountry>(`/operations/festivals/countries`)

export const updateSettingsCountries = (data: SettingsCountryPayload) =>
  http.put<SettingsCountry>('/operations/festivals/countries', data)

export const getSettingsBonuses = () =>
  http.get<Bonuses>(`/operations/festivals/bonus-config`)

export const updateSettingsBonuses = (data: BonusesPayload) =>
  http.put<Bonuses>('/operations/festivals/bonus-config', data)

export const getSettingsTopup = () =>
  http.get<Topup>(`/operations/festivals/top-up-settings`)

export const updateSettingsTopup = (data: TopupPayload) =>
  http.put<Topup>('/operations/festivals/top-up-settings', data)

export const getSettingsTickets = () =>
  http.get<Tickets>(`/operations/festivals/tickets-settings`)

export const updateSettingsTickets = (data: TicketsPayload) =>
  http.put<Tickets>('/operations/festivals/tickets-settings', data)

export const getSettingsSocials = () =>
  http.get<Socials>(`/operations/festivals/social-links-settings`)

export const updateSettingsSocials = (data: SocialsPayload) =>
  http.put<Socials>('/operations/festivals/social-links-settings', data)

export const getSettingsModules = () =>
  http.get<ModuleSettings>(`/operations/festivals/module-settings`)

export const updateSettingsModules = (data: ModuleSettingsPayload) =>
  http.put<ModuleSettings>('/operations/festivals/module-settings', data)

export const getSettingsLanguages = () =>
  http.get<SettingsLanguages[]>(`/operations/festivals/languages`)

export const createSettingsLanguages = (languageIds: any) =>
  http.post<SettingsLanguages[]>('/operations/festivals/languages', languageIds)

export const setDefaultSettingsLanguages = (id: string) =>
  http.patch<SettingsLanguages>(`/operations/festivals/languages/${id}/default`)

export const deleteSettingsLanguage = (id: string) =>
  http.delete(`/operations/festivals/languages/${id}`)

export const getSettingsFriends = () =>
  http.get<SettingsFriends[]>(`/operations/festivals/friend`)

export const updateSettingsFriends = (data: SettingsFriendsPayload[]) =>
  http.put<SettingsFriends[]>('/operations/festivals/friend', data)

export const deleteSettingsWidget = (id: string) =>
  http.delete(`/operations/festivals/friend/${id}`)

export const getFooterSettings = () =>
  http.get<FooterSettings>(`/operations/festivals/footer-settings`)

export const updateFooterSettings = (data: FooterSettingsPayload) =>
  http.put<FooterSettings>('/operations/festivals/footer-settings', data)

export const deleteSettingsFooterBanner = (id: string) =>
  http.delete(`/operations/festivals/footer-banner/${id}`)

export const getSettingsCheckin = () =>
  http.get<CheckinSettings>('/operations/festivals/checkin-settings')

export const updateSettingsCheckin = (data: CheckinSettingsPayload) =>
  http.put<CheckinSettings>('/operations/festivals/checkin-settings', data)

export const uploadParentalConsent = (file: File, locale: string) => {
  const formData = new FormData()
  formData.append('file', file)
  return http.post<{
    fileKey: string
    fileUrl: string
  }>(
    `/operations/festivals/checkin-settings/parental-consent?locale=${locale}`,
    formData,
  )
}

export const getSettingsWebMenu = () =>
  http.get<Menu[]>('/operations/festivals/web-menu')

export const updateSettingsWebMenu = (data: MenuPayload[]) =>
  http.put<Menu[]>('/operations/festivals/web-menu', data)

export const deleteSettingsWebMenu = (id: string) =>
  http.delete(`/operations/festivals/web-menu/${id}`)

export const getSettingsGender = () =>
  http.get<SettingsGender[]>('/operations/festivals/gender')

export const updateSettingsGender = (data: SettingsGenderPayload[]) =>
  http.put<SettingsGender[]>('/operations/festivals/gender', data)

export const deleteSettingsGender = (id: string) =>
  http.delete(`/operations/festivals/gender/${id}`)

export const deleteEmailTemplates = (id: string) =>
  http.delete(`/operations/festivals/email-templates/${id}`)

export const getEditions = () =>
  http.get<FestivalEdition[]>('/operations/festivals/editions')

export const createEditions = (data: FestivalEditionCreate) =>
  http.post<FestivalEdition[]>('/operations/festivals/editions', data)

export const updateEditionSingelEdit = (id: string, data: FestivalEdition) =>
  http.put<FestivalEdition>(`/operations/festivals/editions/${id}`, data)

export const deleteFestivalEdition = (id: string) =>
  http.delete(`/operations/festivals/editions/${id}`)

export const publishFestivalEdition = (id: string) =>
  http.patch(`/operations/festivals/editions/${id}/publish`)

export const getSettingsAppVersion = () =>
  http.get<AppSection>('/operations/festivals/app-settings')

export const updateSettingsAppVersion = (data: AppSection) =>
  http.put<AppSection>('/operations/festivals/app-settings', data)

export const getHeroSettings = () =>
  http.get<HeroSettings>('/operations/festivals/hero-settings')

export const updateHeroSettings = (data: HeroSettingsPayload) =>
  http.put<HeroSettings>('/operations/festivals/hero-settings', data)

export const getPaymentMethodsSettings = () =>
  http.get<IPaymentMethodsSettings>(
    '/operations/festivals/payment-methods-settings',
  )

export const updatePaymentMethodsSettings = (
  data: IPaymentMethodsSettingsPayload,
) =>
  http.put<IPaymentMethodsSettings>(
    '/operations/festivals/payment-methods-settings',
    data,
  )

export const getCryptoSettings = () =>
  http.get<ICryptoSettings>(`/operations/festivals/crypto-settings`)

export const updateCryptoSettings = (data: ICryptoSettingsPayload) =>
  http.put<ICryptoSettings>('/operations/festivals/crypto-settings', data)

export const getGooglePaySettings = () =>
  http.get<IGooglePaySettings>(`/operations/festivals/google-pay-settings`)

export const updateGooglePaySettings = (data: IGooglePaySettingsPayload) =>
  http.put<IGooglePaySettings>(
    '/operations/festivals/google-pay-settings',
    data,
  )

export const getApplePaySettings = () =>
  http.get<IApplePaySettings>(`/operations/festivals/apple-pay-settings`)

export const updateApplePaySettings = (data: IApplePaySettingsPayload) =>
  http.put<IApplePaySettings>('/operations/festivals/apple-pay-settings', data)

export const getAlcatrazSettings = () =>
  http.get<IAlcatrazSettings>(`/operations/festivals/alcatraz-config`)

export const updateAlcatrazSettings = (data: IAlcatrazSettingsPayload) =>
  http.put<IAlcatrazSettings>('/operations/festivals/alcatraz-config', data)

export const getAlcatrazTickets = (params?: IAlcatrazTicketsQuery) =>
  http.get<Pagination<IAlcatrazTicketRow>>(
    '/operations/festivals/alcatraz-tickets',
    { params },
  )

export const registerAlcatrazTicket = (participationId: string) =>
  http.post(`/operations/festivals/alcatraz-tickets/${participationId}/register`)

export const deleteAlcatrazTicket = (participationId: string) =>
  http.delete(`/operations/festivals/alcatraz-tickets/${participationId}`)

export const fixAlcatrazTickets = (view: 'current' | 'passed') =>
  http.post<number>(`/operations/festivals/alcatraz-tickets/fix`, undefined, {
    params: { view },
  })

export const getFinancingSettings = () =>
  http.get<FinancingSettings>('/operations/festivals/financing-settings')

export const updateFinancingSettings = (data: FinancingSettingsPayload) =>
  http.put<FinancingSettings>('/operations/festivals/financing-settings', data)

export const getTaxCategories = () =>
  http.get<TaxCategoriesSettings>('/operations/festivals/tax-categories')

export const updateTaxCategories = (data: TaxCategoriesSettingsPayload) =>
  http.put<TaxCategoriesSettings>('/operations/festivals/tax-categories', data)

export const getFinancialSettingsInvoiceConfig = () =>
  http.get<FinancialSettingsInvoiceConfig>(
    '/operations/financial-settings/invoice-config',
  )

export const updateFinancialSettingsInvoiceConfig = (
  data: Omit<FinancialSettingsInvoiceConfig, 'id'>,
) =>
  http.put<FinancialSettingsInvoiceConfig>(
    `/operations/financial-settings/invoice-config`,
    data,
  )

export const updateFinancialSettingsCategory = (
  id: string,
  data: FinancialSettingsCategory,
) =>
  http.put<FinancialSettingsCategory>(
    `/operations/financial-settings/category/${id}`,
    data,
  )

export const deleteFinancialSettingsCategory = (id: string) =>
  http.delete(`/operations/financial-settings/category/${id}`)

export const getFinancialSettingsCategory = () =>
  http.get<FinancialSettingsCategory[]>(
    `/operations/financial-settings/category`,
  )

export const createFinancialSettingsCategory = (
  data: FinancialSettingsCategory,
) =>
  http.post<FinancialSettingsCategory>(
    `/operations/financial-settings/category`,
    data,
  )

export const getFinancialSettingsCategoryTickets = (id: string) =>
  http.get<FinancialSettingsCategoryTickets>(
    `/operations/financial-settings/category/${id}/tickets`,
  )
